import {
  calculateDaysBetweenDates,
  formatScheduleDate,
} from "../utils/roadmapHelpers";
import TimelineBarOutside from "./TimelineBarOutside";
import TimelineBarInside from "./TimelineBarInside";
import React from "react";

export default function TimelineBar({
  startDate,
  targetDate,
  hasOutsideText = true,
}: {
  startDate?: Date;
  targetDate?: Date;
  hasOutsideText?: boolean;
}) {
  const currentDate = new Date();

  const scheduleDaysTotal =
    startDate && targetDate
      ? calculateDaysBetweenDates(startDate, targetDate)
      : 0;
  const scheduleDaysCurrent = startDate
    ? calculateDaysBetweenDates(startDate, currentDate)
    : 0;

  const stringStartDate =
    startDate && !isNaN(startDate.getTime())
      ? formatScheduleDate(startDate)
      : "--/--/----";
  const stringEndDate =
    targetDate && !isNaN(targetDate.getTime())
      ? formatScheduleDate(targetDate)
      : "--/--/----";
  const progressValue =
    startDate &&
    targetDate &&
    !isNaN(startDate.getTime()) &&
    !isNaN(targetDate.getTime()) &&
    currentDate > startDate
      ? (scheduleDaysCurrent / scheduleDaysTotal) * 100
      : 0;

  const scheduleOutsideText = (
    <TimelineBarOutside
      startDate={stringStartDate}
      endDate={stringEndDate}
      progressValue={progressValue}
    />
  );

  const scheduleInsideText = (
    <TimelineBarInside
      startDate={stringStartDate}
      endDate={stringEndDate}
      progressValue={progressValue}
    />
  );

  return hasOutsideText ? scheduleOutsideText : scheduleInsideText;
}
